<div class="flex-fill center-center">
  <ng-container *ngrxLet="selectInitialLoaded$; let initialLoaded">
    <ng-container *ngrxLet="isEmbedded$; let isEmbedded">
      <ng-container *ngrxLet="keepRatio$; let keepRatio">
        <ng-container *ngrxLet="selectSharedNameAndDate$;let sharedNameAndDate">
          <ng-container *ngrxLet="selectSelectedLocation$;let location">
            <ng-container *ngrxLet="selectType$; let type">
              <ng-container *ngrxLet="selectIsNotFound$; let isNotFound">
                <ng-container *ngrxLet="isRecordProtected$; let isProtected">
                  <ng-container *ngrxLet="selectAccessToken$; let accessToken">
                    <!--          FIRST CHECK IF ALL DATA RECEIVED AND W COULD RUN FLOW-->
                    <ng-container *ngIf="initialLoaded;else loader">
                      <!--            SECOND CHECK IF RECORD IS PROTECTED-->
                      <ng-container *ngIf="!isProtected;else requiredPassword">
                        <!--THIRD CHECK IF NOT FOUND. IN CASE OF ALERT NOT FOUND WILL BE SHOWN IN ARCHIVE OR ALERT IS NOT FOUND-->
                        <ng-container *ngIf="!isNotFound;else expiredLink">
                          <div class="flex-fill granted-access">
                            <ng-container *ngIf="!isEmbedded">
                              <div
                                   class="flex-row space-between-center header"
                                   *ngrxLet="selectConfig$;let config"
                              >
                                <img class="lumana-logo" alt="logo" src="assets/lumana_logo.svg"/>
                                <div class="flex-row space-between-center">
                                  <ng-container *ngIf="config">
                                    <div class="flex-row start-center statistic-section gap-4">
                                      <span class="ui-icon-user"></span>
                                      <span>{{ config.sharedCount }}</span>
                                    </div>
                                    <div>
                                      <span class="dot">.</span>
                                    </div>
                                    <div class="flex-row start-center statistic-section gap-4">
                                      <span class="ui-icon-time"></span>
                                    </div>
                                    <div>
                                      <span class="dot">.</span>
                                    </div>
                                    <div class="flex-row start-center statistic-section gap-4">
                                      <span class="ui-icon-eye"></span>
                                      <span>{{ config?.views }} views</span>
                                    </div>
                                    <ng-container *ngrxLet="selectSharedArchive$; let archive">
                                      <div [matTooltip]="archive?.status === archiveStatus.PROCESSING_TRANSCODE ? ('ARCHIVE.TABLE.PROCESSING'|translate) : ('ARCHIVE.TABLE.PROCESSING_FAILED'|translate)"
                                           [matTooltipDisabled]="!(archive?.status === archiveStatus.PROCESSING_TRANSCODE || archive?.status === archiveStatus.FAILED_TRANSCODE)"
                                        >
                                          <span *ngIf="config.allowDownload"
                                                class="ui-icon-arrow-download icon-hover ml-5 mr-5"
                                                [class.disabled]="archive?.status !== archiveStatus.COMPLETED_TRANSCODE"
                                                (click)="downloadArchive()"
                                          ></span>
                                      </div>
                                    </ng-container>
                                  </ng-container>

                                  <ui-button *ngIf="!this.authenticationService.isLoggedIn()"
                                             class="back-btn"
                                             colorBgr="#FFFFFF"
                                             colorText="#344054"
                                             text="Sign in"
                                             colorBorder="#D0D5DD"
                                             (click)="signIn()"
                                  >
                                  </ui-button>
                                </div>
                              </div>
                            </ng-container>
                            <!--                    <ng-container *ngIf="!isPasswordRequired;else requiredPassword">-->
                            <div class="content-wrapper h-100">
                              <div class="content-inner h-100" [class.embedded]="isEmbedded">
                                <div class="video-container">
                                  <ng-container [ngSwitch]="type">
                                    <ng-container *ngSwitchCase="grantedAccessTypes.ALERT">
                                      <ng-container *ngrxLet="isPanicAlert$; let isPanicAlert">
                                        <app-shared-panic-alert *ngIf="isPanicAlert === true"></app-shared-panic-alert>
                                        <app-shared-alert *ngIf="isPanicAlert === false"
                                                          [sharedArchive]="selectSharedArchive$|ngrxPush"
                                                          [archiveUrl]="archiveUrl" [accessToken]="accessToken"
                                        ></app-shared-alert>
                                        <ui-preloader *ngIf="isPanicAlert === null" [color]="loaderColor.blue"></ui-preloader>
                                      </ng-container>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="grantedAccessTypes.ACCESS_CONTROL_EVENT">
                                     <app-shared-event></app-shared-event>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="grantedAccessTypes.ARCHIVE">
                                      <app-shared-archive [sharedArchive]="selectSharedArchive$|ngrxPush"
                                                          [archiveUrl]="archiveUrl"
                                      ></app-shared-archive>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="grantedAccessTypes.LIVE_VIEW">
                                      <div class="player-wrapper h-100"
                                           style="aspect-ratio: 16/9"
                                           *ngIf="selectSharedLiveView$|async as  sharedLiveView"
                                      >
                                        <app-shared-liveview
                                          [edgeId]="sharedLiveView.edgeId"
                                          [cameraId]="sharedLiveView.cameraId"
                                          [locationId]="sharedLiveView.locationId"
                                          [cameraName]="sharedLiveView?.name"
                                          [accessToken]="accessToken"
                                          [isRespectRatio]="keepRatio"
                                          [location]="location"
                                        ></app-shared-liveview>
                                      </div>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="grantedAccessTypes.PLAYBACK">
                                      <div class="player-wrapper" *ngrxLet="selectSharedPlayBack$; let sharedPlayBack">
                                        <ng-container *ngIf="sharedPlayBack">
                                          <app-playback-player
                                            #playback
                                            class="w-100"
                                            [permissionCheck]="false"
                                            [timezone]="sharedPlayBack.alertCameraTimezone"
                                            [cameraId]="sharedPlayBack.cameraId"
                                            [edgeId]="sharedPlayBack.edgeId"
                                            [locationId]="sharedPlayBack.locationId"
                                            [edgeRegion]="sharedPlayBack.region"
                                            [startTime]="sharedPlayBack.startTime"
                                            [time]="sharedPlayBack.alertTime"
                                            [duration]="sharedPlayBack.endTime - sharedPlayBack.startTime"
                                          ></app-playback-player>
                                        </ng-container>
                                      </div>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="grantedAccessTypes.WALL">
                                      <app-shared-wall></app-shared-wall>
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                      <ui-preloader [color]="loaderColor.blue"></ui-preloader>
                                    </ng-container>
                                  </ng-container>

                                </div>
                                <ng-container *ngIf="!isEmbedded">
                                  <div class="title">
                                    <ng-container *ngIf="type === grantedAccessTypes.LIVE_VIEW; else notLiveView">
                                      {{ (selectSharedLiveView$ | async).name }}
                                    </ng-container>
                                    <ng-template #notLiveView>

                                      {{ sharedNameAndDate.name }}
                                    </ng-template>
                                    <ng-container *ngIf="isPanicAlert$ | async; else regularAddress">
                                      , {{ (panicAddress$ | async) || ('GRANTED_ACCESS.PANIC_ALERT.LOCATION_UNAVAILABLE' | translate) }}
                                    </ng-container>
                                    <ng-template #regularAddress>, {{ location|locationAddress }}</ng-template>
                                  </div>
                                  <span class="description">{{ sharedNameAndDate.timestamp | date : 'dd MMMM, yyyy' }}</span>
                                  <div class="comment-container">
                                    <div class="title">Comments</div>
                                    <ng-container *ngrxLet="selectComments$;let comments">
                                      <ng-container *ngIf="comments?.length">
                                        <div class="comment-wrapper">
                                          <ng-container>
                                            <div class="comment" *ngFor="let comment of comments">
                                              <div class="flex-row start-center">
                                                <ui-avatar class="avatar"
                                                           [color]="'#B2DF8A'"
                                                           [name]="comment.name"
                                                ></ui-avatar>
                                                <span class="name">{{ comment.name }}</span>
                                                <!--                      <span class="label1">at</span>-->
                                                <!--                      <span class="label1 time">03:32</span>-->
                                              </div>
                                              <div class="flex-col comment-body">
                                                <span class="text">{{ comment.text }}</span>
                                                <div class="flex-row start-center">
                         <span class="label1" style="margin-left: 0">
                           {{ comment.timestamp * 1000|date:'MM-dd-YY HH:mm' }}
                         </span>
                                                  <!--                        <span class="dot">.</span>-->
                                                  <!--                        <span class="label1">Delete</span>-->
                                                  <!--                        <span class="dot">.</span>-->
                                                  <!--                        <span class="label1">Edit</span>-->
                                                </div>
                                              </div>
                                              <!--                    <div class="flex-row start-center actions">-->
                                              <!--                      <div class="flex-row start-center reply">-->
                                              <!--                        <mat-icon svgIcon="reply"></mat-icon>-->
                                              <!--                        <span>Reply</span>-->
                                              <!--                      </div>-->
                                              <!--                    </div>-->
                                            </div>
                                          </ng-container>

                                        </div>
                                        <hr class="hr">
                                      </ng-container>
                                      <ng-container *ngIf="!comments?.length && addCommentHide">
                                        <div class="no-comment">
                                          <div class="title">
                                            There aren't any comments yet.
                                          </div>
                                          <div class="description">
                                            Be the first. Add a comment on the video above.
                                          </div>
                                          <ui-button type="default"
                                                     text="Comment"
                                                     (clickAction)="addCommentHide=!addCommentHide"
                                          >

                                          </ui-button>
                                        </div>
                                      </ng-container>
                                      <div class="new-comment">
                                        <ui-button *ngIf="addCommentHide && comments?.length"
                                                   text="Comment"
                                                   icon="chat_bubble_outline"
                                                   colorIcon="#667085"
                                                   colorBgr="white"
                                                   colorText="#344054"
                                                   colorBorder="#D0D5DD"
                                                   (clickAction)="addCommentHide=!addCommentHide"
                                        ></ui-button>

                                        <ui-comment-form *ngIf="!addCommentHide" (saved)="commentAdd($event)"
                                                         (canceled)="cancelComment()"
                                        ></ui-comment-form>
                                      </div>

                                    </ng-container>

                                  </div>
                                </ng-container>
                              </div>
                            </div>

                            <!--                    </ng-container>-->
                          </div>
                        </ng-container>
                      </ng-container>

                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>

            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
<ng-template #loader>
  <ui-preloader [color]="loaderColor.blue"></ui-preloader>
</ng-template>


<ng-template #requiredPassword>
  <div class="h-100 w-100 flex-row center-center">
    <div class="flex-col required-password">
      <div class="title">This video is private</div>
      <div class="sub-title">Enter the password to open this video</div>
      <div class="input-wrapper ui-input-container-no-icon">
        <div class="flex-row space-between-center">
          <span class="input-label">{{ 'AUTH.LOGIN.PASSWORD' | translate }}</span>
          <ng-container [ngTemplateOutlet]="showHidePwdIcon"
                        [ngTemplateOutletContext]="{ field:userPassword }"
          ></ng-container>
        </div>
        <div>
          <mat-icon class="lock-btn">lock</mat-icon>
          <input class="ui-input ui-input-40 w-100 password"
                 type="password"
                 [placeholder]="'AUTH.LOGIN.PASSWORD_PLACEHOLDER' | translate"
                 #userPassword
                 [(ngModel)]="password"
          >
        </div>

      </div>
      <ui-button [disabled]="!password"
                          style="margin-top: 32px"
                          [loading]="isSubmit"
                          [text]="'Submit'"
                          (clickAction)="submitPassword()"
      >
      </ui-button>
    </div>
  </div>
</ng-template>

<ng-template #expiredLink>
  <div class="flex-fill link-expired">
    <div class="inner">
      <img class="lumana-logo" alt="logo" src="assets/lumana_logo.svg"/>
      <div class="flex-row space-between-center">
        <div class="description-block">
          <div class="level-2">Link expired</div>
          <div class="level-3">
            The link you're attempting to access has expired.<br>
            To get a new link, please reach out to the original link owner.<br> Sorry for the inconvenience.
          </div>
          @if (!isMobile) {
            <ui-button colorBgr="#4367F6"
                       colorText="white"
                       text="Go back"
                       class="back-btn"
                       (clickAction)="back()"
            ></ui-button>
          }
        </div>
        <div>
          <!--          <img class="icon" alt="icon" src="assets/not-found-icon.svg"/>-->

        </div>
      </div>
    </div>
  </div>

</ng-template>

<ng-template #showHidePwdIcon let-field="field">
  <ng-container *ngIf="field.type === 'password'">
    <span class="input-label primary flex-row center-center c-p gap-8"
          (click)="field.type= field.type === 'password'?'text':'password'"
    >
      <span class="ui-icon-eye primary"></span>{{ 'COMMON.SHOW' | translate }}
    </span>
  </ng-container>
  <ng-container *ngIf="field.type !== 'password'">
    <span class="input-label primary flex-row center-center c-p gap-8"
          (click)="field.type= field.type === 'password'?'text':'password'"
    >
      <span class="ui-icon-eye_closed primary mr-8"></span>{{ 'COMMON.HIDE' | translate }}
    </span>
  </ng-container>
</ng-template>
